

   <div [ngClass]="{'container-email': !this.classicEditorMediaTypes.includes(this.mediaType)}" class="container">
    <div *ngIf="!isLoading">
      <div id="HEADER" class="mt-4">
        <h2 class="text-center mb-4">CURRENT TEMPLATE</h2>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div [ngClass]="{'preview-notification': this.classicEditorMediaTypes.includes(this.mediaType)}" [innerHTML]="htmlContent"></div>
        </div>
      </div>
      <div id="EMAIL-EDITOR" class="mt-5">
        <h2 class="text-center mb-4">MODIFY TEMPLATE HERE</h2>
      </div>
      <div class="row">
        <div class="col-md-12">
          <email-editor #emailEditor
            (loaded)="initEditor($event)"
            [projectId]=""
            [options]="options"
            [appearance]="appearance()"
          ></email-editor>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-md-12 text-center">
          <button class="btn btn-primary" (click)="saveJSON()">Save Design</button>
        </div>
      </div>
    </div>
    <div *ngIf="isLoading" id="app-loading" class="opac-loading">
      <div class="loader running"></div>
    </div>
  </div>

 
  
  
  